import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import moment from "moment";
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './FT.css';
import  Venta from './CVenta';
import BibliotecaFoto from './BibliotecaFoto';
import "moment/locale/es"; // Importa el idioma español
import Select from 'react-select';

moment.locale("es");
// Estilos para el documento PDF
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    }
});

const MyDocument = () => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text>Sección #1</Text>
            </View>
            <View style={styles.section}>
                <Text>Sección #2</Text>
            </View>
        </Page>
    </Document>
);

const modeloDatos = {
    pacienteID: 0,
    empresaid: 0
    , nombres: ''
    , apellidos: ''
    , cedula: ''
    , telefono: ''
    , celular: ''
    , fechaNacimiento: new Date
    , sexo: ''
    , seguroID: 0
    , poliza: ''
    , direccion: ''
  
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: '',
    citaID: 0
       , diagnostico: ''
    , diagnosticoClinico: ''
    , tratamientoID: 0
    , nombreTratamiento: ''
    , resultado: ''
    , toxicos: ''
    , alergicos: ''
    , antecedentesMedicos: ''
    , antecedentesMedicamentos: ''
    , examenFisico: ''
    , antecedentesFamiliares: ''
    , habitosAlimenticios: '',
    sucursalID:0


}
const Aviso = {
    recepcionPacienteID: 0,
    empresaID:'',
    pacienteID:'',
    fecha:'',
    motivoConsulta: '',
    doctorID:''
    , doctor: '',
    estudioID: '',
    estudio: '',

}
let emp = 0;
const modeloRecord = {
    recordPaciente: 0,
    empresaID: emp,
    pacienteID: 0,
    historiaClinica: '',
    comentario: '',
    fecha: new Date,
    codigoUnico: ''
}
let optionsArticulos = [];
let optionsDoctores = [];

const Seguros = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [tablaAviso, settablaAviso] = useState(Aviso);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [ModalVentas, setModalVentas] = useState(false);
    const [ModalFoto, setModalFoto] = useState(false);
    const [ModalEstudioP, setModalEstudioP] = useState(false);
    const [Consulta, SetConsulta] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [reportUrl, setReportUrl] = useState(null);
    const [ListadoSeg, SetListadoSeg] = useState([]);
    const [ListaDoctores, SetListadoDoctor] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [paciente, Setpaciente] = useState([]);
    const [ListadoRecord, SetListadoRecord] = useState([]);
    const [tablaRecord, setTablaRecord] = useState(modeloRecord);

    const fetchReport = async () => {
        const response = await fetch(Api + "Pacientes/getreport");
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        setReportUrl(url);
    };

    const [cssContent, setCssContent] = useState('');
    useEffect(() => {
        fetch('/css/CPacientes.css')
            .then(response => response.text())
            .then(text => setCssContent(text))
            .catch(error => console.error('Error al cargar el CSS:', error));
    }, []);


    emp = JSON.parse(localStorage.getItem("sesion_usuario")).empresaID;


    let correo = JSON.parse(user).correo;
    const onBusqueda = async (e) => {
        var l = Listado1;

        var searchData = l.filter((item) => {
            if (
                (item.nombres + item.apellidos + item.cedula + item.telefono)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())

            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        if (e.target.name == "sexo") {
            icono(e.target.value)
        }
        if (e.target.name == "cedula" && e.target.value.length > 10) {
            ValidarCedula(e.target.value);
        }
        else {
            setTabla({
                ...tabla,
                [e.target.name]: e.target.value
            })
        }
    }
    const handleChange1 = (e) => {

        settablaAviso({
                ...tablaAviso,
                [e.target.name]: e.target.value
            })
    }


    const ValidarCedula = async (x) => {

        var nomb = Listado.filter(e => e.cedula == x).map(d => d);
        setTabla({
            ...tabla, nombres: "", apellidos: "", cedula: x
        })
        if (nomb.length != 0) {
            var e = nomb[0].nombres + " EXISTE"
            MensajeG(e)
            setVerModal(!verModal);
        }
        else {
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
            if (response1.ok) {
                let data1 = await response1.json()
                if (data1 != false) {
                    icono((data1[0]).sexo);
                    setTabla({
                        ...tabla, nombres: (data1[0]).nombres, apellidos: (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x,
                        fechaNacimiento: (data1[0]).fechaNacimiento, sexo: (data1[0]).sexo
                    })
                } else {
                    setTabla({
                        ...tabla, nombres: "", apellidos: "", cedula: x
                    })
                }
            }
        }
    }

    const MensajeG = (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });


    const obtenerDatos = async (d) => {
        let response = await fetch(Api + "Pacientes/ListaPacientes") ;
        if (response.ok) {
            let data = await response.json()
            SetListado1(data);
          

            if (pendiente== true || d ==1 ) {
                SetListado(data);
                setPendiente(false)
            }
        }
    }

    useEffect(() => {
        obtenerDatos();
        obtenerDatosSeg()
        obtenerDatosDoctor()
        obtenerProductos()
    },[])

    const obtenerDatosSeg = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + correo + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoSeg(data)
        }
    }

    const obtenerProductos = async () => {
        let response = await fetch(Api + "Citas/ListaProductos/" + correo);

        if (response.ok) {
            let data = await response.json()
            var d = data.filter(x => x.empresaID == emp).map(e => e)
                  
            d.map(x => {
                optionsArticulos.push({ value: x.articuloID, label: x.descripcion, nombre: x.descripcion, tab: 'Servicio' })
            })
            tabla.tratamientoID = d[0].articuloID
        }
    }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }

    const obtenerDatosDoctor = async () => {
        let response = await fetch(Api + "CMantenimiento/listaDoctores/" + correo);

        if (response.ok) {
            let data = await response.json()
            var d = data.filter(x => x.empresaID == emp).map(e => e)
            SetListadoDoctor(d)

            d.map(x => {
                optionsDoctores.push({ value: x.doctorID, label: x.nombreDoctor, nombre: x.nombreDoctor, tab: 'Doctor' })
            })
            tabla.especialistaID = d[0].doctorID


        }
    }

    const guardarCambios = async () => {
        let response;
        if (tabla.pacienteID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            tabla.empresaID = JSON.parse(user).empresaID;
          
        
                response = await fetch(Api + "Pacientes/GuardarPacientes", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })
         
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Pacientes/EditarPacientes", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            setPendiente(true)
            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }
        setPendiente(true)
       obtenerDatos(1);
    }


    const guardarCambiosRecord = async () => {
        let response;
        if (tablaRecord.recordPaciente == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            tablaRecord.empresaID = JSON.parse(user).empresaID;
            response = await fetch(Api + "Pacientes/GuardarRecordPaciente", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })

        } else {
            response = await fetch(Api + "Pacientes/EditarRecordPaciente", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })
        }

        if (response.ok) {
            let data1 = await response.json()
            tablaRecord.recordPacienteGastroID = data1.recordPacienteGastroID
            tablaRecord.codigoUnico = data1.codigoUnico

            await ObtenerRecord();
            MensajeG("Guardado")
            // setTablaRecord(modeloRecord);
            Atras()
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const Facturar = (data) => {
        setTabla(data);
        setModalVentas(true);
    }
    const FotoRecord = (data) => {
        setTabla(data);
        setModalFoto(true);
    }
    const NotificarEstudio = async (data) => {
    
        let response = await fetch(Api + "Citas/ConsultaConfirmacionCita/"+data.citaID +"/"+data.telefono);
  settablaAviso(Aviso)
        setTabla(data);
        if (response.ok) {
            let data1 = await response.json()
            var d = data1.filter(x => x.empresaID == emp).map(e => e)[0]
            settablaAviso({
                ...tablaAviso,
                doctorID: d.especialistaID, doctor: d.nombreEspecialista, motivoConsulta: d.comentario, estudioID: d.tratamientoID, estudio: d.nombreTratamiento
            })
 
        }
      
        setModalEstudioP(true);
    }

    const ObtenerRecord = async (d) => {
        let response = await fetch(Api + "Pacientes/ListaRecordPaciente/" + d + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoRecord(data)
        }
    }

    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const abrirRecord = (data) => {
        Setpaciente(data);
        ObtenerRecord(data.pacienteID);
        SetConsulta(true)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.pacienteID,
            sortable: true,
        },
        {
            name: 'Nombre ',
            selector: row => ( row.nombres +" "+ row.apellidos),
            sortable: true,
        },      {
            name: 'Cedula ',
            selector: row => row.cedula,
            sortable: true,
        },     {
            name: 'Telefono ',
            selector: row => row.telefono,
            sortable: true,
        },
        //{
        //    name: 'Seguro ',
        //    selector: row => ( ListadoSeg.find(x => x.seguroID == row.seguroID)?.descripcion ),
        //    sortable: true,
        //},


       
        {
            name: '',
            cell: row => (
                <>
                    {(row.cedula == "" || row.cedula == null )?    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt">Completar Datos</i>
                    </Button>
                   :<div>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                            </Button>
                            <Button color="primary" size="sm" className="mr-2"
                                onClick={() => abrirRecord(row)} title="Proceso de Consulta"
                            >
                                <i className="fas fa-user-tag"></i>
                            </Button>
                  <Button hidden color="warning" size="sm" className="mr-2"
                        onClick={() => NotificarEstudio(row)}
                    >
                        <i className="fas fa-file"> R</i>
                    </Button>                     <Button color="success" size="sm" className="mr-2"
                        onClick={() => Facturar(row)}
                    >
                        <i className="fas fa-money-bill"> </i>
                    </Button>
                            <Button color="warning" size="sm" className="mr-2"
                        onClick={() => FotoRecord(row)}
                    >
                        <i className="fas fa-image"> </i>
                    </Button>
               
</div>
                    }
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const icono = (d) => {
        const profileIcon = document.getElementById('profileIcon');
        if (d === 'F') {
            profileIcon.innerHTML = '👩';
        } else if (d === 'M') {
            profileIcon.innerHTML = '👨';
        } else {
            profileIcon.innerHTML = '👤';
        }
    };

    function calcularEdad(fechaNacimiento, fechaActual) {
        var nacimiento = new Date(fechaNacimiento);
        var actual = new Date(fechaActual);

        var edad = actual.getFullYear() - nacimiento.getFullYear();
        var mes = actual.getMonth() - nacimiento.getMonth();
        var dia = actual.getDate() - nacimiento.getDate();

        // Ajustar si el mes o el día no ha pasado aún este año
        if (mes < 0 || (mes === 0 && dia < 0)) {
            edad--;
        }

        return edad;
    }

    const imprimirRecibo = () => {
        const recibo = document.getElementById("reciboPago").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Historia clinica</title><style>");
        ventana.document.write(cssContent);
        ventana.document.write("</style></head><body>");
        ventana.document.write(` <div class="headerM container"> 
                          
                        </div>      ${recibo}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        //const logoImg = ventana.document.getElementById("logoImg");
        //logoImg.onload = function () {

        //};
        setTimeout(() => {
            ventana.print();
        }, 2000);
        cerrarModal()
      
    };

    const handleChange2 = (e) => {
        if (e.tab == "Seguro") {
            setTabla({
                ...tabla,
                ["seguroID"]: e.value, ["nombreSeguro"]: e.nombre
            })
        } if (e.tab == "Doctor") {
            settablaAviso({
                ...tablaAviso,
              //  ["especialistaID"]: e.value,
                ["doctorID"]: e.value,           ["doctor"]: e.nombre
            })
        } if (e.tab == "Servicio") {
            settablaAviso({
                ...tablaAviso,
                ["estudioID"]: e.value,      ["estudio"]: e.nombre
            })
        }
    }

    const handleChangeRecord = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaRecord({
            ...tablaRecord,
            [e.target.name]: e.target.value
        })
    }
    const Atras = () => {
        SetConsulta(!Consulta)
        Setpaciente([])
    }

    return (
        <>
            <ToastContainer />
            <div hidden>
                <h1>Generar Reporte PDF</h1>
                <PDFDownloadLink document={<MyDocument />} fileName="reporte.pdf">
                    {({ loading }) => (loading ? 'Generando documento...' : 'Descargar PDF')}
                </PDFDownloadLink>
            </div>
            <div hidden>
                <button onClick={fetchReport}>Ver Reporte</button>
                {reportUrl && (
                    <iframe src={reportUrl} width="100%" height="600px"></iframe>
                )}
            </div>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Pacientes
                </CardHeader>
                <CardBody>
                <Row>
                <Col md="2">
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Paciente</Button>
                        </Col>
               <Col>
                        <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de paciente " ></Input>
</Col>
                    </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationPerPage={25}  
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal className="modal-preguntas" isOpen={verModal}>
               
                <ModalBody>
                    <div class="containerp">
                        <div class="form-header">
                            <div class="box">
                                <div>Record del Paciente </div>
                                <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                            </div>

                            <div id="profileIcon" class="profile-icon">👤</div>
                        </div>
                        <form class="form-content">
                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="cedula">Cédula</label>
                                        <input type="text" id="cedula" name="cedula" onChange={handleChange} value={tabla.cedula} maxlength="11" required />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="nombres">Nombres</label>
                                        <input type="text" id="nombres" name="nombres" value={tabla.nombres}
                                            placeholder="Nombres" onChange={handleChange} required />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="apellidos">Apellidos</label>
                                        <input type="text" id="apellidos" name="apellidos" value={tabla.apellidos}
                                            placeholder="Apellidos" onChange={handleChange} required />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="telefono">Teléfono</label>
                                        <input type="tel" id="telefono" name="telefono" mask="999-999-9999"
                                            value={tabla.telefono} onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="celular">Celular</label>
                                        <input type="tel" id="celular" name="celular" mask="999-999-9999" onChange={handleChange} value={tabla.celular} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="fechaNacimiento">Fecha de Nacimiento</label>
                                        <input type="date" id="fechaNacimiento" name="fechaNacimiento" value={moment(tabla.fechaNacimiento).format('YYYY-MM-DD')}
                                            placeholder="FechaNacimiento" onChange={handleChange} />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="sexo">Sexo</label>
                                        <select id="sexo" name="sexo" value={tabla.sexo} onChange={handleChange} >
                                            <option value="">Seleccione</option>
                                            <option value="F">Femenino</option>
                                            <option value="M">Masculino</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="seguro">Seguro</label>
                                        <select id="seguroID" name="seguroID"
                                            value={tabla.seguroID} onChange={handleChange} >
                                            <option value="">Seleccione</option>
                                            {ListadoSeg.map(x =>
                                                <option value={x.seguroID}> {x.descripcion}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="afiliado">Afiliado</label>
                                        <input type="text" id="poliza" name="poliza" value={tabla.poliza}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                            </div>

                       
                         
                            <div class="form-group">
                                <label for="direccion">Dirección</label>
                                <input type="text" id="direccion" name="direccion" value={tabla.direccion} id="Direccion"
                                    onChange={handleChange} />
                            </div>
                            <div class="form-row">
                               
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Descripcion de lo Toxicos</label>
                                        <input type="text" id="toxicos" name="toxicos" value={tabla.toxicos} onChange={handleChange}></input>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Diagnóstico</label>
                                        <input type="text" id="diagnostico" name="diagnostico" value={tabla.diagnostico} id="diagnostico"
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnosticoClinico" style={{ color: "red" }} >DIAGNOSTICO CLINICO IMPORTANTE PARA RECORDAR</label>
                                        <input type="text" id="diagnosticoClinico" name="diagnosticoClinico" value={tabla.diagnosticoClinico}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Familiares</label>
                                        <input type="text" id="antecedentesFamiliares" name="antecedentesFamiliares" value={tabla.antecedentesFamiliares}
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>
                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="toxicos">Alergicos</label>
                                        <input type="text" id="alergicos" name="alergicos" value={tabla.alergicos}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Medicos</label>
                                        <input type="text" id="antecedentesMedicos" name="antecedentesMedicos" value={tabla.antecedentesMedicos}
                                            onChange={handleChange} />
                                    </div>
                                </div>         <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Medicamentos</label>
                                        <input type="text" id="antecedentesMedicamentos" name="antecedentesMedicamentos" value={tabla.antecedentesMedicamentos}
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>
                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="toxicos">Examen Fisico</label>
                                        <input type="text" id="examenFisico" name="examenFisico" value={tabla.examenFisico}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Habitos Alimenticios</label>
                                        <input type="text" id="habitosAlimenticios" name="habitosAlimenticios" value={tabla.habitosAlimenticios}
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>

                        

                           
                            <div class="btn-group">
                                <button type="button" onClick={cerrarModal} class="btn btn-danger">Cerrar</button>
                                <button type="button" class="btn btn-primary" onClick={guardarCambios}>Guardar</button>
                            </div>
                        </form>
                    </div>
                </ModalBody>
       
            </Modal>


            {/*AYUDA VEnta*/}
            <Modal className="modal-preguntas" isOpen={ModalEstudioP}>
                <ModalHeader className="modal-header1">
               
                    <div class="box">
                        <div>        Imprimir Recepcion de Paciente </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setModalEstudioP(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>

                        <div class="row">
                            <div class="label">Estudio:</div>
                            <div class="value">
                

                                            <Select
                                    name="estudio"
                                                onChange={handleChange2}
                                                value={optionsArticulos.find((x) => x.value === tablaAviso.estudioID) || null}
                                                options={optionsArticulos}
                                                classNamePrefix="react-select"
                                              
                                                placeholder="Seleccione el Servicio" />
                                      

                                     
                            </div>
                        </div>
                        <div class="row">
                            <div class="label">Motivo de Estudio:</div>
                            <div class="value">   <Input type="text" id="motivoConsulta" name="motivoConsulta" value={tablaAviso.motivoConsulta} 
                                onChange={handleChange1} /></div>
                        </div>
                           <div class="row">
                            <div class="label">Doctor:</div>
                     
                                <Select
                                name="doctor"
                                    onChange={handleChange2}
                                    value={optionsDoctores.find((x) => x.value === tablaAviso.doctorID) || null}
                                    options={optionsDoctores}
                                    classNamePrefix="react-select"
                                    
                                    placeholder="Seleccione el Especialista" />
                        </div>


 <Button type="button" class="no-print btn" onClick={()=> imprimirRecibo()}>Imprimir</Button>
                        <div id="reciboPago" class="ticket" hidden>

                           
                  
                          
                            <div class="row header">
                                <div class="label">Nombre:</div>
                                <div class="value">{tabla.nombres +" "+tabla.apellidos} </div>
                              
                             </div>

                            <div class="divider"></div>

                            <div class="row">
                                <div class="label">Sexo:</div>
                                <div class="value">{tabla.sexo}</div>
                            </div>
                            <div class="row">
                                <div class="label">Fecha:</div>
                                <div class="value">{ moment(new Date).format("DD/MM/YYYY")}</div>
                            </div>

                            <div class="row">
                                <div class="label">Edad:</div>
                                <div class="value">{calcularEdad(tabla.fechaNacimiento,new Date)}</div>
                            </div>

                            <div class="row">
                                <div class="label">Teléfono:</div>
                                <div class="value">{tabla.telefono}</div>
                            </div>

                            <div class="row">
                                <div class="label">Estudio:</div>
                                <div class="value">{tablaAviso.estudio}</div>
                            </div>

                            <div class="row">
                                <div class="label">Motivo estudio:</div>
                                <div class="value">{tablaAviso.motivoConsulta}</div>
                            </div>

                            <div class="row">
                                <div class="label">Seguro médico:</div>
                                <div class="value">{ListadoSeg.find(x => x.seguroID == tabla.seguroID)?.descripcion}</div>
                            </div>

                            <div class="row">
                                <div class="label">Médico:</div>
                                <div class="value">{tablaAviso.doctor}</div>
                            </div>

                            <div class="row">
                                <div class="label">No:</div>
                                <div class="value">&nbsp;</div>
                            </div>

                            <div class="divider"></div>
                           
                        </div>
                    </Row>
                    <div class="btn-group">
              
                        <button type="button" class="btn btn-primary" onClick={() => setModalEstudioP(false)}>Cerrar</button>
                    </div>
                </ModalBody>

            </Modal>

            {/*AYUDA VEnta*/}
            <Modal className="modal-preguntas" isOpen={ModalVentas}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>        Facturacion </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setModalVentas(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Venta data={tabla } />
                    </Row>
                    <div class="btn-group">
              
                        <button type="button" class="btn btn-primary" onClick={()=>setModalVentas(false)}>Cerrar</button>
                    </div>
                </ModalBody>

            </Modal>

            {/*Subir Foto*/}
            <Modal className="modal-preguntas" isOpen={ModalFoto}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>        SUBIR FOTOS DE  {tabla.nombres} </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setModalFoto(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                       
                        <BibliotecaFoto recordID={tabla.pacienteID} />
                    </Row>
                    <div class="btn-group">

                        <button type="button" class="btn btn-primary" onClick={() => setModalFoto(false)}>Cerrar</button>
                    </div>
                </ModalBody>

            </Modal>

            { //MODAL Record
            }

            <Modal className="modal-preguntas" isOpen={Consulta}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>        Consulta Médica</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => SetConsulta(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <div class="containerR">

                        
                            <div class="patient-info">
                                <div class="info-item">
                                    <span class="info-label">Nombres y Apellidos:</span>
                                    {paciente.nombres + " " + paciente.apellidos}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Edad:</span>

                                    {calcularEdad(paciente.fechaNacimiento, new Date())}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Móvil:</span>
                                    {paciente.celular} /  {paciente.telefono}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">ARS:</span>
                                    {paciente.nombreSeguro}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Afiliado:</span>
                                    {paciente.poliza}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Tóxicos:</span>
                                    {paciente.toxicos}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Alergicos:</span>
                                    {paciente.alergicos}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Antecedentes Medicos:</span>
                                    {paciente.antecedentesMedicos}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Antecedentes Medicamentos:</span>
                                    {paciente.antecedentesMedicamentos}
                                </div>
                                <div class="info-item" style={{ color: "red" }}>
                                    <span class="info-label" style={{ color: "red" }}>MUY IMPORTANTE RECORDAR:</span>
                                    {paciente.diagnosticoClinico}
                                </div>
                            </div>

                            <div class="col-md-16" >
                                <Row>
                                    <Col Col="6">
                                        <h4><b>Consulta</b></h4>
                                        <textarea placeholder="Historia Clínica" name="historiaClinica"
                                            onChange={handleChangeRecord} value={tablaRecord.historiaClinica} ></textarea>
                                        <textarea placeholder="Comentario" name="comentario" value={tablaRecord.comentario}
                                            onChange={handleChangeRecord}></textarea>

                                        <div class="btn-group">
                                            <button type="button" onClick={Atras} class="btn btn-danger">Cerrar</button>
                                            <button type="button" class="btn btn-primary" onClick={guardarCambiosRecord} hidden={!tablaRecord.historiaClinica}>Terminar</button>
                                        </div>
                                    </Col>
                                    <div className="col-md-6">
                                        <h4><b>Historial de consulta</b></h4>
                                        <table >
                                            <thead>
                                                <tr>
                                                    <th>Fecha  </th>
                                                    <th>Descripción</th>
                                                    <th>Comentario</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ListadoRecord.map(x => (
                                                    <tr>
                                                        <td>{moment(x.fecha).format("DD/MM/YY")}</td>
                                                        <td >
                                                            <textarea rows="2" value={x.historiaClinica} disabled></textarea>
                                                        </td>
                                                        <td>
                                                            <textarea rows="2" value={x.comentario} disabled></textarea>
                                                        </td>
                                                  

                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                    </div>
                                </Row>
                            </div>
                        </div>


                    </Row>
                    
                </ModalBody>

            </Modal>

        </>
    )

}
export default Seguros;